module.exports = __webpack_public_path__ + "bd7e36b8e1e0f959ee986fc990cf519a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/wizard-hat.png
// module id = 2805
// module chunks = 0